import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth0 } from "@auth0/auth0-react";
import { Container, Typography, Button, Box } from '@mui/material';

const AuthWrapper = ({ children }) => {
    const { error, logout } = useAuth0();

    useEffect(() => {
        if (error && typeof window !== 'undefined') {
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, [error]);

    if (error) {
        const isUnverifiedEmail = error.message === 'email_not_verified';
        const text = isUnverifiedEmail
            ? 'Ainda não confirmaste o teu endereço de email. Por favor verifica a tua caixa de entrada.'
            : 'Erro de autenticação. Por favor, tenta novamente.';

        return (
            <Container maxWidth="sm">
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    minHeight="100vh"
                    textAlign="center"
                >
                    <Typography variant="h6" gutterBottom>{text}</Typography>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => logout({
                            returnTo: process.env.GATSBY_AUTH0_CALLBACK_URL,
                            federated: true
                        })}
                    >
                        Terminar sessão
                    </Button>
                </Box>
            </Container>
        );
    }

    return children;
};

AuthWrapper.propTypes = {
    children: PropTypes.node
};

export default AuthWrapper;
